import { app } from './Api';

/**
 * Calendário — recursos da API (prefixo REACT_APP_BASE_URL):
 *
 * | Método | Rota              | Uso |
 * |--------|-------------------|-----|
 * | GET    | calendar          | Lista paginada (page, qtdPerPage, title opcional) |
 * | POST   | calendar          | Cria calendário + feriados no body |
 * | GET    | calendar/:id      | Detalhe com calendarioFeriado[] |
 * | PUT    | calendar/:id      | Atualiza nome e substitui todos os feriados |
 * | DELETE | calendar/:id      | Exclui calendário e feriados |
 *
 * Observação: a rota resource `calendario_feriado` existe na API mas não é usada por esta tela;
 * feriados são sempre enviados em `calendarioFeriado` no create/update do calendar.
 */

const BASE = 'calendar';

/**
 * @param {number} page — API usa página 1-based
 * @param {number} rowsPerPage — qtdPerPage
 * @param {string} [title] — filtro por nome (omitido se vazio)
 */
export function listCalendars(page, rowsPerPage, title) {
    const params = { page, qtdPerPage: rowsPerPage };
    if (title != null && String(title).trim() !== '') {
        params.title = String(title).trim();
    }
    return app.get(BASE, { params });
}

/** @param {string|number} id */
export function getCalendarById(id) {
    return app.get(`${BASE}/${id}`);
}

/**
 * @param {{ nome: string, calendarioFeriado: Array<{ nome: string, data_feriado: string }> }} payload
 */
export function createCalendar(payload) {
    return app.post(BASE, payload);
}

/**
 * @param {string|number} id
 * @param {{ nome: string, calendarioFeriado: Array<{ nome: string, data_feriado: string }> }} payload
 */
export function updateCalendar(id, payload) {
    return app.put(`${BASE}/${id}`, payload);
}

/** @param {string|number} id */
export function deleteCalendar(id) {
    return app.delete(`${BASE}/${id}`);
}

/** @deprecated use listCalendars */
export const getCalendar = listCalendars;
/** @deprecated use getCalendarById */
export const getCalendarPerId = getCalendarById;
/** @deprecated use createCalendar */
export const postCalendar = createCalendar;